import 'jquery.cookie'

(function ($) {

    $(document).ready(function () {

        if (document.querySelector(".js-close-cookies-popup")) {
            document.querySelector(".js-close-cookies-popup").addEventListener("click", function (event) {
                event.preventDefault();
                $(".cookie-banner").hide();
                var cookieName = $(this).data("cookie");
                $.cookie(cookieName, true, { expires: 365, path: '/' });
            });
        }

    });

})(jQuery);
